import React from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { GlobeDemo } from "./GlobeDemo";

const Hero = ({ isLandingPage }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine if this is the landing page based on the path or prop
  const isHome = isLandingPage || location.pathname === "/" || location.pathname === "/home";

  const handleGetStarted = () => {
    window.location.href = "/contact";
  };

  const handleScheduleDemo = () => {
    navigate("/contact");
  };

  return (
    <div className={`relative w-full ${isHome ? "min-h-screen pb-20" : "h-[500px]"} bg-gradient-background overflow-hidden`}>
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-secondary/10 to-accent/10" />
      
      {/* Main content */}
      <div className="relative z-20 container mx-auto px-4 py-8 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left content */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-white text-center lg:text-left mx-auto lg:mx-0 max-w-lg lg:max-w-none order-1 lg:order-1"
          >
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-4xl md:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-primary leading-[1.15] md:leading-[1.2]"
            >
              Data Security for<br className="hidden sm:block" /> Digital Enterprise Protection
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-xl text-gray-300 mb-8"
            >
              ANCILE protects all your data at rest, in motion, and in use.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start"
            >
              <button 
                onClick={handleGetStarted}
                className="bg-gradient-primary hover:bg-gradient-secondary text-white px-8 py-4 rounded-lg font-semibold transition-all transform hover:scale-105 shadow-glow"
              >
                Get Started
              </button>
            </motion.div>
          </motion.div>

          {/* Right content - Globe Animation */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className={`relative ${isHome ? "h-[400px] md:h-[450px] lg:h-[550px]" : "h-[300px] md:h-[350px]"} flex items-center justify-center overflow-visible order-2 lg:order-2`}
          >
            <div className="w-full h-full">
              <GlobeDemo />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-background-dark to-transparent" />
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-background-dark to-transparent" />
    </div>
  );
};

export default Hero; 